import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const MenuIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z" />
  </Icon>
)
